import { StepStatus } from '@/enums/StepStatus';

export const updateGeneratedPlan = async (response, statusType, store, planId) => {
  if (!response) return;
  const currentPlan = response.data;
  currentPlan.plan.status[statusType] = StepStatus.PROCESS;
  store.commit('crm/setCurrentPlan', currentPlan);
  await Promise.all([
    store.dispatch('crm/getCrmPlan3dById', planId),
    store.dispatch('substances/getPresetsList', { crm_plan_ids: [planId] }),
  ]);
};
